// extracted by mini-css-extract-plugin
export default {"content":"mimic___styles_content__eFnaC"};